import {
  Lit3formBlock,
  html,
  unsafeHTML,
  classMap,
  icon,
} from '@Root/lib/lit-3form-block';
import { styles } from './css';

import {
  analyticsCtaDataObject,
  analyticsLabelFromString,
  handleFileDownloadEvent,
} from '../../../helpers/adobe-analytics';
import '@Root/lib/lit-3form-block/components/cta-text';

export class Tommy extends Lit3formBlock {
  static get characterName() {
    return 'tommy';
  }

  static get characterStyles() {
    return [...styles];
  }

  static properties = {
    _selectedCircleChoice: { type: Object },
    _selectedRectangleChoice: { type: Object },
    _selectedMobileButtonIndex: { type: Number },
    _rectangleChoicePosition: { type: Array },
    _carouselImagesArray: { type: Array },
    _selectedCarouselImageIndex: {
      type: Number,
      state: true,
      hasChanged: (newValue, oldValue) => {
        return newValue !== oldValue;
      },
    },
    _currentCarouselImage: { type: Object },
    _currentDownloadLinks: { type: Array },
    _showRectangleOptionIds: { type: Array },
    startingCircleChoiceIndex: { type: Number },
  };

  constructor() {
    super();

    this._selectedCircleChoice = {};
    this._selectedRectangleChoice = {};
    this._selectedMobileButtonIndex = 0;
    this._rectangleChoicePosition = [0, 0];
    this._carouselImagesArray = [];
    this._selectedCarouselImageIndex = 1;
    this._currentCarouselImage = {};
    this._currentDownloadLinks = [];
    this._showRectangleOptionIds = [];

    this.startingCircleChoiceIndex = 1;

    this.setChoicesData();
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid tommy-layout">
          <div class="block-descriptions">
            <p class="eyebrow">${unsafeHTML(this.eyebrowText)}</p>
            <h2>${unsafeHTML(this.headingText)}</h2>
            <p class="description">${unsafeHTML(this.descriptionText)}</p>
            <div class="text-sections">
              ${this.textSectionsHTML}
            </div>
          </div>
          <div class="carousel-wrapper">
            ${this._carouselImagesArray.length
              ? html`
                  <span class="carousel-image">
                    <span
                      @click="${() => this.changeCarouselImage('previous')}"
                      class="carousel-arrows left-arrow"
                    >
                      ${icon('arrow')}
                    </span>
                    <span class="carousel-image-wrapper">
                      <span class="top-spacer-mobile"></span>
                      <img
                        src=${this.imagebossUrl(
                          this._currentCarouselImage.src,
                          '800',
                          null
                        )}
                      />
                      <span class="carousel-controls-mobile">
                        ${Array.from(
                          { length: this._carouselImagesArray.length },
                          (indicator, index) => {
                            const isSelectedIndicator =
                              index === this._selectedCarouselImageIndex;
                            return html`
                              <span
                                class=${classMap({
                                  'carousel-indicator': true,
                                  'selected-indicator': isSelectedIndicator,
                                })}
                              ></span>
                            `;
                          }
                        )}
                      </span>
                    </span>
                    <span
                      @click="${() => this.changeCarouselImage('next')}"
                      class="carousel-arrows right-arrow"
                    >
                      ${icon('arrow')}
                    </span>
                  </span>
                  <div class="image-caption-wrapper">
                    <image-caption
                      description=${this._currentCarouselImage
                        .thumbnail_description || ''}
                    >
                      <a
                        slot="control"
                        href=${this._currentCarouselImage.full_resolution_src}
                        target="_blank"
                        download
                        @click="${() =>
                          this.carouselImageDownloadClicked(
                            this._currentCarouselImage
                          )}"
                      >
                        <span id="download-icon">
                          ${icon('download-large')}
                        </span>
                      </a>
                    </image-caption>
                    <span class="carousel-controls">
                      ${this.carouselSelectorData.map((selector, index) => {
                        const selectedCarouselImg =
                          index === this._selectedCarouselImageIndex;
                        return html`
                          <span
                            class=${classMap({
                              'not-selected-border': true,
                              'selected-border': selectedCarouselImg,
                            })}
                            @click="${() => this.changeCarouselImage(index)}"
                          >
                            <img src="${selector}" />
                          </span>
                        `;
                      })}
                    </span>
                  </div>
                `
              : html``}
          </div>
          <div class="options">
            <hr />
            ${this.rectangleOptionsHTML}
            <hr />
            ${this.circleOptionsHTML}
            <hr />
            ${this.downloadsHTML}
          </div>
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get rectangleOptionsHTML() {
    return this.rectangleChoicesDataIsReady
      ? html`
          <div class="rectangle-options-desktop">
            ${this.rectangleChoicesData.map((group, groupIndex) => {
              return html`
                <div class="rectangle-option-group">
                  <h4>${group.title}</h4>
                  <div class="rectangle-group-options">
                    ${group.options.map((option, optionIndex) => {
                      const selectedRectangleChoice =
                        option.id === this._selectedRectangleChoice.id;
                      return html`
                        <span
                          @click="${() =>
                            this.rectangleChoiceSelected(
                              groupIndex,
                              optionIndex
                            )}"
                          class=${classMap({
                            'rectangle-option-wrapper': true,
                            'not-selected-border': true,
                            'selected-border': selectedRectangleChoice,
                          })}
                        >
                          <img
                            src="${this.imagebossUrl(option.image.src, 150)}"
                          />
                          <p class="option-label">${option.label}</p>
                        </span>
                      `;
                    })}
                  </div>
                </div>
              `;
            })}
          </div>
          <div class="rectangle-options-mobile">
            <div class="mobile-buttons-wrapper">
              ${this.rectangleChoicesData.map((group, groupIndex) => {
                const isSelectedMobileButton =
                  groupIndex === this._selectedMobileButtonIndex;
                return html`
                  <span
                    class=${classMap({
                      'mobile-button': true,
                      'selected-mobile-button': isSelectedMobileButton,
                    })}
                    @click="${() => this.mobileButtonSelected(groupIndex)}"
                  >
                    <p>${group.title}</p>
                  </span>
                `;
              })}
            </div>
            <div class="mobile-rectangle-choices">
              ${this.mobileSelectedRectangleGroupData.map(group => {
                group.options.map((option, optionIndex) => {
                  const selectedMobileButton =
                    optionIndex === this._selectedMobileButtonIndex;
                  return html`
                    <span
                      @click="${() =>
                        this.rectangleChoiceSelected(
                          this._selectedMobileButtonIndex,
                          optionIndex
                        )}"
                      class=${classMap({
                        'mobile-button': true,
                        'selected-mobile-button': selectedMobileButton,
                      })}
                    >
                      <img src="${this.imagebossUrl(option.image.src, 150)}" />
                      <p class="option-label">${option.label}</p>
                    </span>
                  `;
                });
              })}
            </div>
            ${this.mobileSelectedRectangleGroupData.map(group => {
              return html`
                <div class="mobile-rectangle-carousel">
                  <span
                    @click="${() => this.moveMobileCarousel('left')}"
                    class="carousel-arrows left-arrow"
                  >
                    ${icon('arrow')}
                  </span>
                  <div
                    class="mobile-rectangle-group-options"
                    id="mobile-carousel"
                  >
                    ${group.options.map((option, optionIndex) => {
                      const selectedRectangleChoice =
                        option.id === this._selectedRectangleChoice.id;
                      return html`
                        <span
                          @click="${() =>
                            this.rectangleChoiceSelected(
                              this._selectedMobileButtonIndex,
                              optionIndex
                            )}"
                          class=${classMap({
                            'mobile-rectangle-option-wrapper': true,
                            'not-selected-border': true,
                            'selected-border': selectedRectangleChoice,
                          })}
                          id="mobile-rectangle-${optionIndex}"
                        >
                          <img
                            src="${this.imagebossUrl(option.image.src, 150)}"
                          />
                          <p class="option-label">${option.label}</p>
                        </span>
                      `;
                    })}
                  </div>
                  <span
                    @click="${() => this.moveMobileCarousel('right')}"
                    class="carousel-arrows right-arrow"
                  >
                    ${icon('arrow')}
                  </span>
                </div>
              `;
            })}
          </div>
        `
      : html``;
  }

  get circleOptionsHTML() {
    return this.circleChoicesData &&
      Object.keys(this.circleChoicesData).length > 0
      ? html`
          <div class="circle-options">
            ${this.circleChoicesData.option_groups.map((group, groupIndex) => {
              return html`
                <div class="circle-option-group">
                  ${group.options.length
                    ? html`
                        ${group.options.map((option, optionIndex) => {
                          const selectedChoice =
                            option.id === this._selectedCircleChoice.id;
                          return html`
                            <img
                              @click="${() =>
                                this.circleChoiceSelected(
                                  groupIndex,
                                  optionIndex
                                )}"
                              class=${classMap({
                                'circle-option-img': true,
                                'not-selected-border': true,
                                'selected-border': selectedChoice,
                              })}
                              src="${this.imagebossUrl(
                                option.image.src,
                                50,
                                50
                              )}"
                            />
                          `;
                        })}
                      `
                    : html``}
                </div>
              `;
            })}
          </div>
        `
      : html``;
  }

  get textSectionsHTML() {
    return this.content.text_sections?.length > 0
      ? html`
          ${this.content.text_sections.map(section => {
            return html`
              <span class="text-section">
                <p class="text-section-header">
                  ${unsafeHTML(this.withLineBreaks(section.heading))}
                </p>
                ${section.paragraphs?.length > 0
                  ? section.paragraphs.map(paragraph => {
                      return html`
                        <p class="text-section-paragraph">
                          ${unsafeHTML(paragraph)}
                        </p>
                      `;
                    })
                  : html``}
              </span>
            `;
          })}
        `
      : html``;
  }

  get downloadsHTML() {
    return this._currentDownloadLinks?.length
      ? html`
          <div class="download-links">
            <h4>DOWNLOADS</h4>
            ${this._currentDownloadLinks.map(download => {
              return html`
                <cta-text
                  .ctaData=${download}
                  .ctaAnalyticsData=${analyticsCtaDataObject(
                    download,
                    this.headingText
                  )}
                  hide-right-arrow-svg="true"
                  target-blank="true"
                  left-download-svg="true"
                ></cta-text>
              `;
            })}
          </div>
        `
      : html``;
  }

  get eyebrowText() {
    return this.content.eyebrow || '';
  }

  get headingText() {
    return this.content.heading || '';
  }

  carouselImageDownloadClicked(image) {
    handleFileDownloadEvent(
      analyticsCtaDataObject({
        file_format: 'JPG',
        file_name: analyticsLabelFromString(
          image.thumbnail_description || this.headingText
        ),
        link_url: image.full_resolution_src,
        link_type: 'IMAGE',
        placement: analyticsLabelFromString(this.headingText),
      })
    );
  }

  get descriptionText() {
    return this.content.description || '';
  }

  get image() {
    return this.content.image || null;
  }

  get imageUrl() {
    return this.image?.src || '';
  }

  get fullResolutionImgUrl() {
    return this.image?.full_resolution_src || '';
  }

  get imageDescription() {
    const regex = /\s*\r\n|\r|\n\s*/gi;
    return this.image?.description
      ? this.image.description.replaceAll(regex, '<br>')
      : '';
  }

  get ctaData() {
    return JSON.stringify(this.content.cta);
  }

  get rectangleChoicesDataIsReady() {
    return (
      this.rectangleChoicesData &&
      !!Object.keys(this.rectangleChoicesData).length
    );
  }

  setChoicesData() {
    this.circleChoiceSelected(0, this.startingCircleChoiceIndex);
    this.rectangleChoiceSelected(0, 0);
  }

  rectangleChoiceSelected(groupIndex, optionIndex) {
    if (!!this.rectangleChoicesData[groupIndex]?.options) {
      this._rectangleChoicePosition = [groupIndex, optionIndex];
      this._selectedRectangleChoice = this.rectangleChoicesData[
        groupIndex
      ].options[optionIndex];

      this._carouselImagesArray =
        this._selectedRectangleChoice?.carousel_images || [];

      this._currentCarouselImage = this._carouselImagesArray[
        this._selectedCarouselImageIndex
      ];

      if (this._selectedRectangleChoice?.download_links)
        this._currentDownloadLinks = this._selectedRectangleChoice?.download_links;

      this.changeCarouselImage(this._selectedCarouselImageIndex);
    }
  }

  circleChoiceSelected(groupIndex, optionIndex) {
    if (!!this.circleChoicesData?.option_groups) {
      this._selectedCircleChoice = this.circleChoicesData?.option_groups[
        groupIndex
      ]?.options[optionIndex];
      this._showRectangleOptionIds = this.colorSpecificRectangleOptionIds;
      this.rectangleChoiceSelected(...this._rectangleChoicePosition);
    }
  }

  changeCarouselImage(selection) {
    const imagesCount = this._carouselImagesArray.length;
    const currentId = this._selectedCarouselImageIndex;
    switch (selection) {
      case 'previous':
        currentId === 0
          ? (this._selectedCarouselImageIndex = imagesCount - 1)
          : this._selectedCarouselImageIndex--;
        break;
      case 'next':
        currentId === imagesCount - 1
          ? (this._selectedCarouselImageIndex = 0)
          : this._selectedCarouselImageIndex++;
        break;
      case 0:
      case 1:
      case 2:
        this._selectedCarouselImageIndex = selection;
        break;
    }
    this._currentCarouselImage = this._carouselImagesArray[
      this._selectedCarouselImageIndex
    ];
  }

  get rectangleChoicesData() {
    if (!this.content.choices) return [];
    const rectangleChoicesIndex = this.content.choices
      .map(choice => choice.selection_style)
      .indexOf('rectangle_images');
    const allRectangleChoices = this.content.choices[rectangleChoicesIndex];
    if (!Object.keys(this._selectedCircleChoice).length) {
      this.circleChoiceSelected(0, this.startingCircleChoiceIndex);
    }

    const filteredRectangleChoicesByColorSelection = [];
    allRectangleChoices.option_groups.forEach((group, index) => {
      const filteredGroup = [];
      group.options.forEach(option => {
        if (this._showRectangleOptionIds?.includes(option.id)) {
          filteredGroup.push(option);
        }
      });
      filteredRectangleChoicesByColorSelection[index] = {
        title: group.title,
        options: filteredGroup,
      };
    });
    return filteredRectangleChoicesByColorSelection;
  }

  get mobileSelectedRectangleGroupData() {
    return [this.rectangleChoicesData[this._selectedMobileButtonIndex]];
  }

  mobileButtonSelected(index) {
    this._selectedMobileButtonIndex = index;
  }

  moveMobileCarousel(direction) {
    const mobileCarousel = this.shadowRoot.getElementById('mobile-carousel'),
      firstChild = this.shadowRoot.getElementById('mobile-rectangle-0'),
      childrenWidth = firstChild.offsetWidth,
      currentScrollPosition = mobileCarousel.scrollLeft,
      currentLeftIndex = Math.floor(currentScrollPosition / childrenWidth);
    let newIndex = 0;

    if (direction === 'left') {
      newIndex = currentLeftIndex - 1;
      if (newIndex === -1) newIndex = 0;
    } else if (direction === 'right') {
      newIndex = currentLeftIndex + 1;
      if (newIndex > mobileCarousel.childElementCount - 1) newIndex = 0;
    }

    const scrollToId = `mobile-rectangle-${newIndex}`;
    this.shadowRoot.getElementById(scrollToId).scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'start',
    });
  }

  get circleChoicesData() {
    if (!this.content.choices) return [];
    const circleChoicesIndex = this.content.choices
      .map(choice => choice.selection_style)
      .indexOf('circle_images');

    return this.content.choices[circleChoicesIndex];
  }

  get carouselSelectorData() {
    return [
      '/static/icons/SVG/tommy_image_choice_1.svg',
      '/static/icons/SVG/tommy_image_choice_2.svg',
      '/static/icons/SVG/tommy_image_choice_3.svg',
    ];
  }

  get colorSpecificRectangleOptionIds() {
    return this._selectedCircleChoice?.option_ids?.map(id => parseFloat(id));
  }
}
Tommy.defineElement();
